import { render, staticRenderFns } from "./ImportTextFiles.vue?vue&type=template&id=6572bc64"
import script from "./ImportTextFiles.vue?vue&type=script&lang=js"
export * from "./ImportTextFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports